
import declare from "dojo/_base/declare";
import enums from "csi/enums";
import csiStore from "csi/store/_base";
import Names, { StoreNames } from "csi/store/Names";
import xml from "csi/xml";
import DataPackageTemplateSheet from "./DataPackageTemplateSheet";
import reflection from "csi/reflection";
import { Field } from "csi/def/Field";
import { Relationship } from "csi/def/Relationship";

const NESTED_SHEET_PARENT_TYPE = "NestedSheetParentType";
const TYPE = "Type";

const DataPackageTemplateNestedSheet = declare(DataPackageTemplateSheet, {
	_bHideNestedSheetParentSubtype: false,
	_bHideType: false,

	/**
	 * @override
	 * Modify DataSheetType store based on datasheets available to NestedSheetParentType
	 */
	getFieldStore(field: Field, value: string): StoreNames {
		var node = this.getViewNode();
		var parentType = xml.enumGetText(this.defView.getFieldValue(NESTED_SHEET_PARENT_TYPE));
		if (node && !parentType) {
			parentType = xml.enumGetText(node[NESTED_SHEET_PARENT_TYPE]);
		}
		var name = field.getControlName();
		var templateType = xml.enumGetText(this.defView.m_formData.getParent().TemplateType);


		if (name == NESTED_SHEET_PARENT_TYPE) {
			if (templateType === "Food" || templateType == "FoodSKU") {
				return enums.getStore(field.getEnumId(), null, (value) => (value !== "ProductType:Style"));
			} else if (templateType == "FormulatedMaterial") {
				return enums.getStore(field.getEnumId(), null, (value) => (value !== "ProductType:Food" && value !== "ProductType:Style" && value !== "ProductType:Material"));
			} else if (templateType == "Material") {
				return enums.getStore(field.getEnumId(), null, (value) => (value !== "ProductType:Food" && value !== "ProductType:Style" && value !== "ProductType:FormulatedMaterial"));
			}
		}

		if (name == TYPE && parentType) {
			return this._getDataSheetTypeStore(field, value, parentType);
		}

		return this.inherited<StoreNames>(arguments);
	},

	_getStore(r: Relationship) {
		var storeOptions = { data: [csiStore.nameObject("")] };
		csiStore.namesOptionsByRelationship(this.getContext(), r, storeOptions);
		return new Names(storeOptions);
	},

	/**
	 * Filter out data sheets based on product type
	 */
	_getDataSheetTypeStore(field: Field, value: string, productType: string): StoreNames {
		const rc = reflection.getClass(productType);

		const store = enums.getStore(field.getEnumId(value), null, (enumValue: string) => {
			const type = this._removeShapeFromType(xml.enumGetText(enumValue));

			if (("Artwork" === type) && ["FormulatedMaterial", "Material"].includes(productType)) {
				return false;
			}

			if (("ApparelBOM" === type) && ["FormulatedMaterial", "Food", "Material"].includes(productType)) {
				return false;
			}
			
			if (("FoodLabelDataSheet" === type) && ["Style", "Material"].includes(productType)) {
				return true;
			}
			let typeParent = reflection.getTypeAttributeDestination(type, xml.ATTR_PARENT)?.type;

			if (typeParent === "Colorway") {
				typeParent = "Style";
			}

			return rc.isDerivedFrom(typeParent);
		});

		return store;
	},

	/**
	 * Reset members
	 */
	_redraw() {
		this._bHideNestedSheetParentSubtype = false;
		this._bHideType = false;
		this.inherited(arguments);
	},

	_updateFieldVisibility(field?: Field) {
		var b = this.inherited(arguments);

		if (!field || (field.m_id == NESTED_SHEET_PARENT_TYPE)) {
			this.setFieldHidden(TYPE, this._bHideType);
			return true;
		}

		return b;
	},
});

export = DataPackageTemplateNestedSheet;